import axios from "@/utils/axios";

export default {
  login(data) {
    return axios.post("/user/login", {
      email: data.email,
      password: data.password,
    });
  },

  register(data) {
    return axios.post("/user/register", {
      email: data.email,
      full_name: data.full_name,
      password: data.password,
    });
  },

  getAuthUser() {
    return axios.get("/user");
  },

  forgotPassword(email) {
    return axios.post("/user/forgot-password", {
      email: email,
    });
  },

  resetPassword(data) {
    return axios.post(`/user/change-password/${data.token}`, {
      password: data.password,
      re_password: data.re_password,
    });
  },

  getListKeyAuthUser() {
    return axios.get("/key/list");
  },

  logout() {
    return axios.post("/v1/user/logout");
  },

  changePasswordUser(data) {
    return axios.post(`/user/change_password/`, {
      old_password: data.old_password,
      password: data.password,
      re_password: data.re_password,
    });
  },
};
